import { useSelector } from 'react-redux';

import { MemberLogin } from "@checkout-b/listing/components/MemberLogin";
import  ListingDatePicker  from "@checkout-v/series/containers/ListingDatePicker";

export const EmbeddedCalendarComponent = () => {
  const isMembershipAvailable = !!useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.membership_available);
  const isMembershipSkipped = !!useSelector(state => state.ui?.skipMembership);
  const hasMembershipInstance = !!useSelector(state => state.reservation?.hasMembershipInstance);

  return (
    <>
      { isMembershipAvailable && !isMembershipSkipped && !hasMembershipInstance
        && <MemberLogin/> }
      { (!isMembershipAvailable || isMembershipSkipped || hasMembershipInstance)
        && <ListingDatePicker/> }
    </>
  );
};
